import { PageHeader } from '../../components/ui/PageHeader.js';
import { PenaltiesSection } from './PenaltiesSection.js';

/** 393 (#1313): "See my penalties" from the booking form lands here; each row opens its penalty. */
export function PenaltiesPage() {
  return (
    <div className="bg-bg px-4 py-6">
      <PageHeader title="My penalties" fallback="/account" />
      <PenaltiesSection />
    </div>
  );
}
